<div class="tw-w-full">
  <div
    class="tw-mt-2 tw-min-h-[56px] tw-rounded-md tw-border-[#9e9e9e] dark:tw-border-[#74747d] tw-border tw-flex-center tw-font-medium tw-mb-3 tw-relative"
  >
    <span
      class="tw-absolute tw-text-sm tw-bg-white dark:tw-bg-dark-500 tw-font-normal tw-px-3 tw-py-1 tw-right-[20px] tw-text-[#707983] dark:tw-text-[#667492] tw-top-[-12px]"
    >
      {{ "common.chooseSendDays" | translate }}
    </span>
    <div class="tw-w-full tw-flex-col tw-px-4 tw-pt-6 tw-pb-4">
      <div
        class="tw-mt-1 tw-mb-4 tw-flex tw-items-start tw-justify-center tw-flex-col tw-font-normal tw-text-gray-600 dark:!tw-text-gray-300"
      >
        <p class="tw-mb-0.5">
          {{ "messages.showCalender" | translate }}
        </p>
        <p class="tw-mb-0.5">
          {{ "messages.chooseDaysFromCalender" | translate }}
        </p>
        <p class="tw-font-semibold tw-mb-0.5">
          {{ "messages.defaultDaysOfWeekIsSelected" | translate }}
        </p>
      </div>

      <!-- button -->
      <div class="tw-w-full tw-flex tw-justify-between border p-2 rounded">
        <button
          (click)="getCalendarApi()"
          class="btn btn-light-info tw-cursor-pointer tw-min-w-[145px]"
          [disabled]="disabled()"
        >
          @if(loading){
          <span
            class="spinner-border spinner-border-sm"
            role=" status"
            aria-hidden="true"
          ></span>
          } @else{
          <span>
            {{ "common.showCalender" | translate }}
            <i class="mdi mdi-22px tw-mx-2 mdi-calendar-range"></i>
          </span>
          }
        </button>

        <div class="tw-flex-between" *ngIf="selectedDays()?.length">
          <div
            class="mx-2 tw-font-normal tw-text-gray-500 dark:tw-text-gray-300 tw-min-w-[40px]"
          >
            {{ "common.selectedDaysCount" | translate }}
          </div>
          <b class="badge badge-light mx-1 p-3 tw-text-[13px]"
            >{{ selectedDays()?.length | numberSeparator }}
          </b>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- <mat-menu #selectedDaysMenu="matMenu" xPosition="before">
  <ul class="tw-max-h-[500px] tw-overflow-y-scroll">
    @for(day of selectedSolarDays;track $index ){
    <li class="m-2">
      {{ day }}
    </li>
    }
  </ul>
</mat-menu> -->
